module.exports = __webpack_public_path__ + "img/level-3.aa03f344.png";